module.exports = __webpack_public_path__ + "img/silver.3c16abc5.png";